import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Toursnavbar from './Toursnavbar';
import Footer from './Footer';
import '../styles/FinalCart.css'; // You can create styles based on the layout

const FinalCart = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const bookingData = state || {
    originalPrice: 189304,
    discountedPrice: 133972,
    visa: true,
    flights: true,
    travellers: 2,
    couponDiscount: 61712,
    taxes: 12760,
  };

  const handleProceedToPayment = () => {
    alert("Booking confirmed!");
    navigate('/'); // or navigate('/payment')
  };

  return (
    <div className="final-cart-container">
      <Toursnavbar />
      <div className="breadcrumb">Home &gt; Holidays &gt; Bookings</div>
      <h2 className="page-title">Secure Booking</h2>

      <div className="refundable-banner">
        <p><strong>Partially refundable before Sat, Sep 7 '24, 11:59pm (local time)</strong><br />
        You can change or cancel this deal for a full refund if plans change. Because flexibility matters.</p>
      </div>

      <div className="booking-summary-box">
        <div className="tour-header">
          <h3>Spectacular Krabi and Phuket Getaway</h3>
          <p>🛫 4 Flights | 🏨 4 Hotels | 🎟️ 7 Activities | 🚐 3 Transfers | 🛂 4 Visa</p>
          <p>26/11/2024 - 01/12/2024 / From New Delhi</p>
        </div>

        <div className="summary-columns">
          <div className="fare-breakup">
            <h4>Fare Breakup</h4>
            <p>Total Basic Cost<br /><strong>₹1,89,304</strong><br /><span>₹94,652 x 2 Travellers</span></p>
            <p>Coupon Discount<br /><strong>-₹61,712</strong></p>
            <p>Fees & Taxes<br />TDS 5.0%: ₹6,380<br />GST 5.0%: ₹6,380<br /><strong>+₹12,760</strong></p>
          </div>

          <div className="coupons-section">
            <h4>Coupons & Offers</h4>
            <p>Have a Coupon Code? <a href="#">Enter Code</a></p>
            <div className="coupon-box">
              <p><strong>GRAND OFFER</strong><br />Grab special offers on all your favorite destinations</p>
              <p className="coupon-discount">-3,985 <button className="remove-btn">REMOVE</button></p>
            </div>
            <div className="coupon-box">
              <p><strong>GRAND OFFER</strong><br />Grab special offers on all your favorite destinations</p>
              <p className="coupon-discount">-3,985</p>
            </div>
            <p className="more-coupons">+8 More</p>
          </div>

          <div className="grand-total-box">
            <h4>Grand Total - {bookingData.travellers} Adults</h4>
            <p className="grand-amount">₹{bookingData.discountedPrice.toLocaleString()}</p>
            <p className="note">(Inclusive of GST)</p>
            <p className="info-text">
              I confirm that I have read and I accept 
              <a href="#"> Cancellation Policy</a>, 
              <a href="#"> User Agreement</a>, 
              <a href="#"> Terms of Service</a> and 
              <a href="#"> Privacy Policy</a> of Vgovia.
            </p>
            <button className="confirm-button" onClick={handleProceedToPayment}>
              PROCEED TO PAYMENT
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FinalCart;
